/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($brandName: String) {
    BrandNameCreate(brandName: $brandName) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
